import { getItem, saveItem } from 'helpers/storage/session-storage';
import Location from 'services/Location';

const NO_SIGN_UP_KEY = 'no_sign_up';

// Created to hide SignUp section in LiveChat Mobile app on iOS platform
// (to be compliant with 5.1.1 App Store review guideline)
export const shouldHideSignup = () => {
  const noSignUpFromUrl = Location.getUrlParam(NO_SIGN_UP_KEY);

  const noSignUpFromStorage = getItem(NO_SIGN_UP_KEY);

  const clientId = Location.getUrlParam('client_id');

  if (
    noSignUpFromUrl === '1' ||
    noSignUpFromStorage === 1 ||
    clientId === import.meta.env.VITE_APP_CONTEXT_EVENT_CLIENT_ID
  ) {
    saveItem(NO_SIGN_UP_KEY, 1);

    return true;
  }

  return false;
};
